import logger from '@/modules/Logger';
import { getDeviceAccessInstance } from '@/utils/getDeviceAccess';

export default {
  async setVideoDevice(deviceId) {
    if (this.videoEffect !== 'none') {
      await this.virtualBackground.setProvider('agora').performSegmentation(deviceId);
      this.videoDevice = deviceId;
      return this.rtc;
    }

    if (this.constraints.screen) {
      return;
    }

    await getDeviceAccessInstance.getCameraDevice(deviceId);

    if (!this.localVideoTrack) {
      this.constraints.cameraId = this.videoDevice = deviceId || null;
      await this.createCameraTracks();
      const stream = await this.publishTracks();
      return { stream };
    }

    return this.localVideoTrack.setDevice(deviceId).then(() => {
      logger.info('Camera device is switched', { operation: 'device:switch', payload: { deviceId } });
    }).then(() => {
      this.videoDevice = deviceId;
      return this.getMediaStream();
    }).catch((error) => {
      logger.error('Error on switching camera', {
        operation: 'device:switch',
        reason: error,
        event_type: 54,
        lesson_id: this.lessonId
      });
      return { error };
    });
  }
};
